const MODULE = 'session'

export const LOGGED_IN_CHANGED = `${MODULE}/LOGGED_IN_CHANGED`
export const STORE_TOKEN = `${MODULE}/STORE_TOKEN`
export const STORE_USER_DATA = `${MODULE}/STORE_USER_DATA`
export const STORE_FORBIDDEN_ERROR = `${MODULE}/STORE_FORBIDDEN_ERROR`
export const CLEAR_FORBIDDEN_ERROR = `${MODULE}/CLEAR_FORBIDDEN_ERROR`
